import { styled } from '@mui/material'
import React, { FC, PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

const StyledContainer = styled('div')`
  position: fixed;
  bottom: 14px;
  right: 0px;
  z-index: 5;
  overflow: hidden;
  transition:
    border-radius 0.3s ease-in-out,
    transform 0.3s ease-in-out;
`
const ReCaptchaPortal: FC<PropsWithChildren<unknown>> = ({
    children,
}) => {
    const container = document.getElementById('captcha-badge')
    if (!container) {
        return null
    }

    return (
        <>
            {createPortal(<StyledContainer>{children}</StyledContainer>, container)}
        </>
    )
}
export default ReCaptchaPortal